/*
 * コンサルタント ホットライン関連の作成
 */
import { apiCreate } from '@/actions/ApiBaseActions';
export const API_CREATE_PROFESSIONAL_HOTLINE_REQUEST = 'API_CREATE_PROFESSIONAL_HOTLINE_REQUEST';
/** コンサルタント ホットライン：申し込み作成 */
export const apiCreateProfessionalHotlineRequest = ({ json, path: { id } }, meta) => apiCreate(API_CREATE_PROFESSIONAL_HOTLINE_REQUEST, `/professional/hotline/${id}/request`, json, meta);
